import React from "react";
import ReactApexChart from "react-apexcharts";
import useInsights from "../../hooks/useInsights";

const PatientBookingSummaryChart = () => {
  const { data: insights } = useInsights();

  const chartData = {
    labels: ["Today", "This Week", "This Month"],
    series: [
      insights?.bookingsToday ?? 0,
      insights?.bookingsThisWeek ?? 0,
      insights?.bookingsThisMonth ?? 0,
    ],
  };

  const chartOptions = {
    chart: {
      type: "polarArea",
      toolbar: { show: false },
    },
    labels: chartData.labels,
    stroke: {
      colors: ["#fff"],
    },
    fill: {
      opacity: 0.9,
    },
    legend: {
      position: "bottom",
      fontSize: "13px",
    },
    colors: ["#FEBA17", "#298E9F", "#195761"], // matching your brand colors
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: { height: 320 },
          legend: { position: "bottom", fontSize: "12px" },
        },
      },
      {
        breakpoint: 480,
        options: {
          chart: { height: 280 },
          legend: {
            position: "bottom",
            fontSize: "11px",
            itemMargin: { horizontal: 6, vertical: 2 },
          },
          yaxis: { labels: { style: { fontSize: "10px" } } },
        },
      },
    ],
  };

  return (
    <div className="rounded-xl p-3 sm:p-6 w-full overflow-hidden">
      <h2 className="text-base sm:text-xl font-bold text-textPrimary text-center mb-2 sm:mb-4">
        Patient Booking Summary
      </h2>

      <ReactApexChart
        options={chartOptions}
        series={chartData.series}
        type="polarArea"
        width="100%"
        height={350}
      />
    </div>
  );
};

export default PatientBookingSummaryChart;